import React, { useState } from "react";
import Layout from "./Layout";

export default function Home() {
  return (
    <div className='relative w-full min-h-screen bg-zinc-950 '>
      <Layout />
    </div>
  );
}
